import moment from "moment";
import { CopyTextToClipboard } from "../../../helpers/copy";
import { tagsBageStatus } from "../../../helpers/tagsBage";
import { Tag } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { Component } from "react";

export class MainInfo extends Component {
  render() {
    let { t, data } = this.props;
    return (
      <>
        <div className="media-body">
          <ul className="pl-3" style={{ listStyle: "none" }}>
            <li className="hover">
              <strong style={{ fontWeight: "700", color: "InfoText" }}>
                {t("UUID")}
              </strong>{" "}
              : {data?.customer_uuid}{" "}
              <CopyOutlined
                onClick={() => CopyTextToClipboard(data?.customer_uuid)}
                className="hover"
              />
            </li>
            <li className="hover">
              <strong style={{ fontWeight: "700", color: "InfoText" }}>
                {t("Name")}
              </strong>{" "}
              : {data?.name}{" "}
              <CopyOutlined onClick={() => CopyTextToClipboard(data?.name)} />
            </li>
            <li className="">
              <strong style={{ fontWeight: "700", color: "InfoText" }}>
                {t("Bank Account")}
              </strong>{" "}
              : {t(data?.bank_code)} ({data?.bank_code})
            </li>
            <li className="hover">
              <strong style={{ fontWeight: "700", color: "InfoText" }}>
                {t("Account Number")}
              </strong>{" "}
              : {data?.account_no}{" "}
              <CopyOutlined
                onClick={() => CopyTextToClipboard(data?.account_no)}
              />
            </li>
            <li className="hover">
              <strong style={{ fontWeight: "700", color: "InfoText" }}>
                {t("telephoneNumber")}
              </strong>{" "}
              : {data?.telephoneNumber || "-"}{" "}
              {data?.telephoneNumber && (
                <CopyOutlined
                  onClick={() => CopyTextToClipboard(data?.telephoneNumber)}
                />
              )}
            </li>
            <li >
              <strong style={{ fontWeight: "700", color: "InfoText" }}>
                {t("createdAt")}
              </strong>{" "}
              : {moment(data?.created_at).format("YYYY-MM-DD HH:mm:ss") || "-"}{" "}
            </li>
            <li className="mt-2 ">
              <strong style={{ fontWeight: "700", color: "InfoText" }}>
                {t("Status")}
              </strong>{" "}
              :{" "}
              <Tag
                color={tagsBageStatus(data?.status)}
                
                children={
                  <>{data?.status === "SUCCESS" ? "Active" : "Inactive"}</>
                }
              />
            </li>
          </ul>
        </div>
      </>
    );
  }
}
